import { Injectable } from '@angular/core';
import { ManagedDocument } from '../common/models/document.model';

@Injectable({ providedIn: 'root' })
export class DocumentManagerImportService {
  dataUrlToBlob(dataUrl: string) {
    const [meta] = dataUrl.split(',');
    const mimeMatch = meta.match(/data:(.*);base64/);
    const mimeType = mimeMatch?.[1] ?? 'application/octet-stream';
    const bytes = this.dataUrlToUint8Array(dataUrl);
    return new Blob([bytes.slice()], { type: mimeType });
  }

  async bytesToDataUrl(bytes: Uint8Array, mimeType: string) {
    return await new Promise<string>((resolve, reject) => {
      const blob = new Blob([bytes.slice()], { type: mimeType });
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(blob);
    });
  }

  dataUrlToUint8Array(dataUrl: string) {
    const [, base64] = dataUrl.split(',');
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
  }

  async blobToUint8Array(blob: Blob) {
    return new Uint8Array(await blob.arrayBuffer());
  }

  async documentToUint8Array(document: ManagedDocument) {
    if (document.blob) {
      return await this.blobToUint8Array(document.blob);
    }
    if (document.dataUrl) {
      return this.dataUrlToUint8Array(document.dataUrl);
    }
    throw new Error('Document has no readable content');
  }

  async documentToBlob(document: ManagedDocument) {
    if (document.blob) {
      return document.blob;
    }
    if (document.dataUrl) {
      return this.dataUrlToBlob(document.dataUrl);
    }
    throw new Error('Document has no readable content');
  }
}
